<template>
  <div class="comments">
    <div class="commentItemView" v-for="(commentItem, commentIndex) in data" :key="commentItem.pk">
      <ReplyItem
        type="comment"
        :item="commentItem"
        :key="commentItem.pk"
        :owner-info="ownerInfo"
        :has-line="commentIndex !== data.length - 1 && commentItem.reply_count === 0"
      />
      <div class="replysView">
        <Replys 
          :owner-info="ownerInfo" 
          :comment-item="commentItem" 
        />
      </div>
    </div>
    <div v-if="postItem.real_comment_count > data.length" :class="`loadMore ${data.length && data[data.length-1].replys.length === 0 ? 'borderTop':'' }`" @click.stop="loadMoreComment()">查看更多</div>
  </div>
</template>

<script>
// @ is an alias to /src
import ReplyItem from "./ReplyItem.vue";
import Replys from "./Replys.vue";

import { types as CommunityTypes } from "@/store/modules/community";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "Comments",
  components: {
    ReplyItem,
    Replys
  },
  props: {
    ownerInfo: {
      type: Object
    },
    postItem: {
      type: Object
    },
    from:{
      type: String,
      default: 'PostList'
    }
  },
  data() {
    return {
      page: 1,
      load_more: false,
      data: [],
      total_count: 0
    };
  },
  watch: {
    comment_data(value) {
      let response = value;
      // 这里判断一下请求所用的帖子 id 是否与当前组件一致。
      if (this.postItem.pk === response.post_id) {
        if (response.next) {
          this.load_more = true;
        } else {
          this.load_more = false;
        }

        if (this.page === 1) {
          this.data = response.results;
        } else {
          this.data = this.data.concat(response.results);
        }
        this.total_count = response.count;
      }
    }
  },
  computed: {
    ...mapState({
      comment_data: state => state.community.comment_data
    })
  },
  methods: {
    ...mapActions({
      fetchCommentList: CommunityTypes.FETCH_COMMENT_LIST
    }),

    loadMoreComment() {
      console.log(this.from)
      if(this.from === 'PostList'){
        // 去到详情页
        this.$router.push(`/post/${this.postItem.pk}`);
      }else{
        // 加载更多数据
        if (this.data.length < 10) {
          this.page = 1;
        } else {
          this.page += 1;
        }
        console.log(`加载更多评论(${this.postItem.pk})`, this.page);
        this.fetchCommentList({ page: this.page, post_id: this.postItem.pk });
      }
    },

    //----------子组件 ReplyItem 的回调函数
    //点赞评论或回复
    likeReplyEvent(type, data) {
      if(this.$parent.likeReplyEvent){
        this.$parent.likeReplyEvent(type, data)
      }
    },
    // 删除事件
    deleteReplyEvent(type, data) {
      if(this.$parent.deleteReplyEvent){
        this.$parent.deleteReplyEvent(type, data)
      }
    },
    // 送花事件
    flowerReplyEvent(type, data){
      if(this.$parent.flowerReplyEvent){
        this.$parent.flowerReplyEvent(type, data)
      }
    },
    
    //对评论的回复或对回复的回复
    publishReply(type, data) {
      if(this.$parent.publishReply){
        this.$parent.publishReply(type, data)
      }
    },
    // 关注事件
    followReplyEvent(type, data){
      if(this.$parent.followReplyEvent){
        this.$parent.followReplyEvent(type, data)
      }
    },
  },
  created() {},
  destroyed() {},
  mounted() {
    this.data = this.postItem.comments;
  }
};
</script>

<style lang="less" scoped>
.comments {
  width: 100%;
  .commentItemView{
    width: 100%;
    .replysView{
      margin-left: 40px;
      padding: 0px 10px;
      width: calc(100% - 60px);
      background-color: #eaeaec;
    }
  }
  .loadMore {
    display: block;
    height: 35px;
    line-height: 35px;
    text-align: center;
    margin-bottom: -10px;
    font-size: 12px;
    cursor: pointer;
    &.borderTop {
      border-top-style: solid;
      border-top-width: 1px;
      border-color: #d9d9d9;
    }
  }
}
</style>
